/*
 * @author        zach.william@zumper.com (Zach William)
 * @copyright     Copyright (c) 2022, Zumper
 * @description   selectorsDetail.ts
 */

import { createSelector } from '@reduxjs/toolkit'
import type { State } from '@zcode/state-type'
import { selectRoot } from './selectorsRoot'

export const selectDetail = createSelector(selectRoot, (state) => state.detail)

export const selectEntity = createSelector(selectDetail, (detail) => detail.entity.data)

export const selectEntityFetching = createSelector(
  selectDetail,
  (detail) => detail.entity.meta.fetching
)

export const selectIsShortTermViewV1 = createSelector(
  selectEntity,
  (entity) => !!entity && entity.isShortTermViewV1
)

/**
 * Given that we're on a detail page, is it the new (2023 Q1) detail page?
 *
 * If called when we're **not** on a detail page, this function *may* still return true,
 * but that value probably isn't particularly meaningful.
 *
 * @param state
 */
export function isDetailPageNew(state: State): boolean {
  const isShortTerm = selectIsShortTermViewV1(state)
  return !isShortTerm
}

export const selectIsAddressOnBuilding = createSelector(
  selectDetail,
  (detail) => !!detail.isAddress
)
